// File: src/components/layout/SearchModal.js

import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './SearchModal.module.css';
import { SEARCH_INDEX } from '../../config/searchIndex.generated';
// import { SEARCH_INDEX } from '../../config/constants';
import { searchSite } from '../../utils/helpers';

function SearchModal({ isOpen, onClose }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen && inputRef.current) {
      setTimeout(() => inputRef.current.focus(), 100);
    }
    if (!isOpen) {
      setQuery('');
      setResults([]);
    }
  }, [isOpen]);

  // Scroll lock — same reliable pattern as team modal
  useEffect(() => {
    if (!isOpen) return;
    const y = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${y}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    return () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, y);
    };
  }, [isOpen]);

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    if (isOpen) window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  const handleSearch = useCallback((value) => {
    setQuery(value);
    setResults(searchSite(value, SEARCH_INDEX));
  }, []);

  const handleSelect = (result) => {
    onClose();
    setTimeout(() => {
      navigate(result.path);
      if (result.anchor) {
        setTimeout(() => {
          const el = document.getElementById(result.anchor);
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
      }
    }, 50);
  };

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()} data-lenis-prevent>

        <div className={styles.inputWrapper}>
          <svg className={styles.searchIcon} width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="9" cy="9" r="6" stroke="currentColor" strokeWidth="1.5" />
            <path d="M13.5 13.5L17 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          <input
            ref={inputRef}
            type="text"
            value={query}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Search GreenScience..."
            className={styles.input}
            autoComplete="off"
          />
          <button className={styles.closeBtn} onClick={onClose} aria-label="Close search">
            <span>ESC</span>
          </button>
        </div>

        {query.length >= 2 ? (
          <div className={styles.results}>
            {results.length === 0 ? (
              <p className={styles.noResults}>No results found for "{query}"</p>
            ) : (
              <ul className={styles.resultList}>
                {results.map((result, i) => (
                  <li key={`${result.path}-${i}`}>
                    <button className={styles.resultItem} onClick={() => handleSelect(result)}>
                      <div className={styles.resultTitle}>{result.title}</div>
                      <div className={styles.resultDesc}>{result.description}</div>
                      <span className={styles.resultPath}>{result.path}</span>
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ) : (
          <div className={styles.hints}>
            <p>Try searching for "solution", "impact", or "partner"</p>
          </div>
        )}

      </div>
    </div>
  );
}

export default SearchModal;